import BranchesLayout from './Layout'
import BranchesList from './List'
import BranchesForm from './Form'

export default [
  {
    path: 'branches',
    component: BranchesLayout,
    redirect: {
      name: 'BranchesList'
    },
    name: 'branches',
    meta: {
      breadcrumb: 'Sedes'
    },
    children: [
      {
        path: 'list',
        alias: '',
        component: BranchesList,
        name: 'BranchesList',
        meta: {
          breadcrumb: 'Lista'
        }
      },
      {
        path: 'add',
        alias: '',
        component: BranchesForm,
        name: 'BranchesAdd',
        meta: {
          breadcrumb: 'Agregar'
        }
      },
      {
        path: 'edit/:id',
        alias: '',
        component: BranchesForm,
        name: 'BranchesEdit',
        meta: {
          breadcrumb: 'Editar'
        }
      }
    ]
  }]
